import styled from 'styled-components/macro';

/** Based on Fukol logic: https://github.com/Heydon/fukol-grids */
const DefinitionList = styled('dl')`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

/** @component */
export default DefinitionList;
